export const SETTING_BANK = {
  SET_SHOW_MODAL: 'SET_SHOW_MODAL',
  SET_SHOW_BANK_ACCOUNT_TABLE: 'SET_SHOW_BANK_ACCOUNT_TABLE',
  GET_SETTING_BANK_ACCOUNTS: 'GET_SETTING_BANK_ACCOUNTS',
  GET_SETTING_BANK_ACCOUNTS_SUCCESS: 'GET_SETTING_BANK_ACCOUNTS_SUCCESS',
};
